"use client";

import { motion } from "framer-motion";
import { HOW_ITS_CALCULATED_LINE_ITEMS } from "./constants";
import type { CardLineVariant } from "./types";

const valueStyles: Record<CardLineVariant, string> = {
  default: "text-[#343434] text-sm font-medium",
  positive: "text-green-600 text-sm font-medium",
  negative: "text-red-500 text-sm font-medium",
  medium: "text-[#343434] text-sm font-medium",
  semibold: "text-[#343434] text-sm font-semibold",
};

const labelStyles: Record<CardLineVariant, string> = {
  default: "text-[#6B6B6B] text-sm font-normal",
  positive: "text-[#6B6B6B] text-sm font-normal",
  negative: "text-[#6B6B6B] text-sm font-normal",
  medium: "text-[#343434] text-sm font-medium",
  semibold: "text-[#343434] text-sm font-medium",
};

export function HeroCard() {
  return (
    <motion.div
      initial={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4, boxShadow: "0 32px 96px rgba(0,0,0,0.12)" }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full max-w-110 bg-white rounded-3xl border border-[#E8E6E3] shadow-[0_24px_80px_rgba(0,0,0,0.08)] p-8 md:p-10"
    >
      {/* Confidence badge */}

      <div className="inline-flex items-center gap-1.5 px-3 py-1  bg-[#F0FDF4] text-sm font-medium text-[#16A34A] rounded-full mb-8 select-none">
        <span
          className="w-1.5 h-1.5 rounded-full bg-[#16A34A] shrink-0"
          aria-hidden="true"
        />
        High confidence
      </div>

      {/* Label */}
      <p className="text-sm text-gray-400 mb-2 leading-snug">
        Safe to spend today
      </p>

      {/*  amount */}
      <p className="text-[64px] font-semibold text-text-primary leading-none mb-8 tracking-tight">
        £3,247
      </p>

      {/* Divider */}
      <div className="border-t border-gray-100 mb-6" />

      {/* Line items */}
      <ul className="space-y-3 pb-3">
        {HOW_ITS_CALCULATED_LINE_ITEMS.map((item) => (
          <li key={item.label} className="flex items-center justify-between">
            <span className={labelStyles[item.variant]}>{item.label}</span>
            <span className={valueStyles[item.variant]}>{item.value}</span>
          </li>
        ))}
      </ul>
      {/* Divider */}
      <div className="border-t border-gray-100" />
      <ul className="space-y-3 py-3 pb-4">
        <li className="flex items-center justify-between">
          <span className={labelStyles["medium"]}>Safe to spend</span>
          <span className={valueStyles["semibold"]}>£3,247</span>
        </li>
      </ul>
      {/* Footer */}
      <div className="border-t border-gray-100 pt-6 flex items-center justify-between">
        <span className="text-xs  text-gray-400 font-normal">
          Last updated: <span className="font-medium">Just now</span>
        </span>

        <div className="flex items-center gap-1.5">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className="text-gray-400"
          >
            <path
              d="M7 1L1 3.5v4.5c0 3.5 2.5 6.2 6 7 3.5-.8 6-3.5 6-7V3.5L7 1z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-xs text-gray-400 font-normal">TrueLayer</span>
        </div>
      </div>
    </motion.div>
  );
}
